import React, { useState } from 'react';

import { DSelect, passParamsThrough } from '../../../validation/HForm';
import { Message } from '../../utilites';

import './unitSelection.scss';

const UnitSelection = ({ errors, commonError, loading = false, cashboxes, h, ...props }) => {
  const [state, setState] = useState({
    leader: '',
    chiefAccountant: '',
    accountant: '',
    seniorCommodityExpert: '',
  });
  const option = cashboxes.map((item) => {
    return item && { label: item?.name, value: item?.id };
  });

  const handleOnChange = (i) => {
    const item = cashboxes.find((item) => item.id === i.value);

    setState(() => ({
      leader: item?.leader?.fullName,
      chiefAccountant: item?.chiefAccountant?.fullName,
      accountant: item?.accountant?.fullName,
      seniorCommodityExpert: item?.seniorCommodityExpert?.fullName,
    }));
  };

  return passParamsThrough(
    <fieldset>
      {commonError && <Message type={'error'} text={commonError} />}
      <div className="form-element unitSelection-element">
        <label className="form-element-label">Подразделение</label>
        <div className="form-element-data-input">
          <DSelect
            h={h}
            name="availableDepartments"
            isLoading={loading}
            options={option}
            handleOnChange={handleOnChange}
            placeholder="Выберите"
            defaultValue={null}
            isSearchable={true}
          />
        </div>
      </div>
      <div className="content-card-content unitSelection-card">
        <div className="form-row unitSelection">
          <div className="form-row-item unitSelection-item">
            <div className="form-element">
              <label className="form-element-label" htmlFor="#">
                Должность
              </label>
              <div className="form-element-data date">
                <div className="form-element-data-text">
                  <p>Руководитель</p>
                </div>
              </div>
            </div>
          </div>
          <div className="form-row-item">
            <div className="form-element">
              <label className="form-element-label" htmlFor="#">
                ФИО
              </label>
              <div className="form-element-data">
                <div className="form-element-data-text">
                  <p>{state.leader}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="form-row unitSelection">
          <div className="form-row-item unitSelection-item">
            <div className="form-element">
              <label className="form-element-label" htmlFor="#">
                Должность
              </label>
              <div className="form-element-data">
                <div className="form-element-data-text">
                  <p>Гл. бухгалтер</p>
                </div>
              </div>
            </div>
          </div>
          <div className="form-row-item">
            <div className="form-element">
              <label className="form-element-label" htmlFor="#">
                ФИО
              </label>
              <div className="form-element-data">
                <div className="form-element-data-text">
                  <p>{state.chiefAccountant}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="form-row unitSelection">
          <div className="form-row-item unitSelection-item">
            <div className="form-element">
              <label className="form-element-label" htmlFor="#">
                Должность
              </label>
              <div className="form-element-data">
                <div className="form-element-data-text">
                  <p>Бухгалтер</p>
                </div>
              </div>
            </div>
          </div>
          <div className="form-row-item">
            <div className="form-element">
              <label className="form-element-label" htmlFor="#">
                ФИО
              </label>
              <div className="form-element-data">
                <div className="form-element-data-text">
                  <p>{state.accountant}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="form-row unitSelection">
          <div className="form-row-item unitSelection-item">
            <div className="form-element">
              <label className="form-element-label" htmlFor="#">
                Должность
              </label>
              <div className="form-element-data">
                <div className="form-element-data-text">
                  <p>Старший товаровед</p>
                </div>
              </div>
            </div>
          </div>
          <div className="form-row-item">
            <div className="form-element">
              <label className="form-element-label" htmlFor="#">
                ФИО
              </label>
              <div className="form-element-data">
                <div className="form-element-data-text">
                  <p>{state.seniorCommodityExpert}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </fieldset>,
    { ...props, errors },
  );
};

export default UnitSelection;
